/* Sleep homepage — "The doctor". One motion idea: on desktop the portrait drifts a few pixels inside its frame
   while the glow behind it drifts the other way. No GSAP / reduced motion / phone = a still, finished portrait. */
(function () {
  'use strict';
  var DTS = (window.DTS = window.DTS || {});
  function init(main, DTS) {
    var root = document.getElementById('dts-doctor');
    if (!root || root.getAttribute('data-drift') === 'false') return;
    if (DTS.reduce || !window.gsap || !window.ScrollTrigger || !window.gsap.matchMedia) return;
    var img = root.querySelector('[data-dts-doctor-img]');
    var glow = root.querySelector('[data-dts-doctor-glow]');
    if (!img) return;
    var gsap = window.gsap;
    gsap.matchMedia().add('(min-width: 990px) and (prefers-reduced-motion: no-preference)', function () {
      root.classList.add('is-drift');
      var st = { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.6 };
      var a = gsap.fromTo(img, { yPercent: -1.5 }, { yPercent: 1.5, ease: 'none', scrollTrigger: st });
      var b = glow ? gsap.fromTo(glow, { yPercent: 5 }, { yPercent: -5, ease: 'none', scrollTrigger: { trigger: root, start: 'top bottom', end: 'bottom top', scrub: 0.9 } }) : null;
      return function () {
        root.classList.remove('is-drift');
        if (a.scrollTrigger) a.scrollTrigger.kill(); a.kill();
        if (b) { if (b.scrollTrigger) b.scrollTrigger.kill(); b.kill(); }
        gsap.set([img, glow], { clearProps: 'transform' });
      };
    });
  }
  if (typeof DTS.register === 'function') DTS.register('doctor', init);
  else { DTS.modules = DTS.modules || []; DTS.modules.push({ name: 'doctor', fn: init }); }
})();
